
import BrandLogos from '@/graphql/queries/taxonomies/BrandLogos'
import { nthChild } from 'vessel/utils'

export default {
  props: {
    type: {
      type: String,
      default: 'plain'
    },
    items: {
      type: [Number, String],
      default: 4
    },
    wrap: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    logo: {
      $type: {
        borderWidth(val) {
          return val == 'grid' ? true : null
        },
        textAlign(val) {
          return val == 'grid' ? 'center' : null
        }
      }
    },
    link: {
      outline: 'none',
      display: 'inline-block',
      width: 'full',
      height: 'full',
      $type: {
        padding(val) {
          return val == 'grid' ? 'sm' : null
        }
      },
      md: {
        $type: {
          padding(val) {
            return val == 'grid' ? 'md' : null
          }
        }
      }
    }
  },
  watch: {
    queryVariables: '$fetch'
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: BrandLogos,
      variables: this.queryVariables
    })

    this.brands = data.children
  },
  data() {
    return {
      brands: null
    }
  },
  computed: {
    autoFill() {
      return this.type == 'grid' ? { all: 'xl', md: '2xl' } : null
    },
    gap() {
      return this.type == 'grid' ? 'sm' : 'md'
    },
    width() {
      return this.type == 'grid' ? { all: 'lg', md: 'lg' } : { all: 'md', md: 'lg' }
    },
    queryVariables() {
      if (this.items == 'all') {
        return { where: { kind: 'brand' } }
      } else {
        return { where: { kind: 'brand' }, children: this.items }
      }
    }
  },
  methods: {
    itemLink(item) {
      const route = { name: 'brands-id', params: { id: item.slug } }
      return item.slug ? this.$pagePath(route) : this.$pagePath('/products')
    },
    logoClass(index) {
      const background = nthChild((index + 1), '2n') && this.$screen.lg
        ? 'grey-lightest'
        : 'white'

      const classes = this.$vessel.apply({
        backgroundColor: this.type == 'grid' ? background : null
      })

      return { ...this.$vessels.logo, ...classes }
    }
  }
}
